import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Fragment } from 'react';
import { fetchSecurityPolicyDefinitions } from '../../apis/core/securityPolicyDefinitions';
export var DiscussionForm = /*#__PURE__*/function (_React$Component) {
  _inherits(DiscussionForm, _React$Component);

  var _super = _createSuper(DiscussionForm);

  function DiscussionForm(props) {
    var _this;

    _classCallCheck(this, DiscussionForm);

    _this = _super.call(this, props);

    _this.validate = function (values) {
      var result = {};

      if (values.title === null || values.title === '') {
        result.title = 'Title must not be empty';
      }

      return result;
    };

    _this.submit = function (event) {
      event && event.preventDefault && event.preventDefault();

      _this.setState({
        dirty: false,
        saving: true
      });

      if (typeof _this.props.onSubmit === 'function') {
        _this.props.onSubmit(_this.state.values, function () {
          return _this.setState({
            saving: false
          });
        });
      }
    };

    _this.handleChange = function (event) {
      var field = event.target.id;
      var value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          values: _objectSpread(_objectSpread({}, state.values), {}, _defineProperty({}, field, value)),
          dirty: true
        });
      });
    };

    _this.handleBlur = function (event) {
      var field = event.target.id;

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          touched: _objectSpread(_objectSpread({}, state.touched), {}, _defineProperty({}, field, true))
        });
      });
    };

    _this.handleJoinPolicyChange = function (event) {
      var name = event.target.value;

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          values: _objectSpread(_objectSpread({}, state.values), {}, {
            joinPolicy: name ? {
              name: name
            } : null
          }),
          dirty: true
        });
      });
    };

    _this.state = {
      values: props.discussion ? {
        title: props.discussion.title,
        description: props.discussion.description,
        isPrivate: props.discussion.isPrivate,
        joinPolicy: props.discussion.joinPolicy,
        owningUsers: props.discussion.owningUsers.toJS(),
        owningTeams: props.discussion.owningTeams.toJS(),
        isArchived: props.discussion.isArchived
      } : {
        title: props.defaults && props.defaults.title || '',
        description: props.defaults && props.defaults.description || '',
        isPrivate: false,
        joinPolicy: null,
        owningUsers: props.defaults && props.defaults.owningUsers || [],
        owningTeams: [],
        isArchived: false
      },
      touched: {},
      dirty: false,
      saving: false,
      editing: !!props.discussion,
      securityPolicyDefinitions: []
    };
    return _this;
  }

  _createClass(DiscussionForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetchSecurityPolicyDefinitions().then(function (_ref) {
        var securityPolicyDefinitions = _ref.securityPolicyDefinitions;
        return _this2.setState({
          securityPolicyDefinitions: securityPolicyDefinitions
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var OwningUsersInput = this.props.renderOwningUsersInput;
      var OwningTeamsInput = this.props.renderOwningTeamsInput;
      var validations = this.validate(this.state.values);
      return this.props.render({
        formElement: /*#__PURE__*/React.createElement("form", {
          onSubmit: this.submit
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-group required ".concat(validations.title && this.state.touched.title ? 'has-error' : '')
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "title"
        }, "Title"), /*#__PURE__*/React.createElement("input", {
          id: "title",
          type: "text",
          value: this.state.values.title,
          onChange: this.handleChange,
          onBlur: this.handleBlur
        }), validations.title && this.state.touched.title && /*#__PURE__*/React.createElement("p", {
          className: "text-danger"
        }, validations.title)), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "description"
        }, "Description"), /*#__PURE__*/React.createElement("textarea", {
          id: "description",
          value: this.state.values.description,
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-check-inline"
        }, /*#__PURE__*/React.createElement("input", {
          className: "form-check-input",
          id: "isPrivate",
          type: "checkbox",
          checked: this.state.values.isPrivate,
          onChange: this.handleChange
        }), /*#__PURE__*/React.createElement("label", {
          className: "form-check-label",
          htmlFor: "isPrivate"
        }, "Private?")), /*#__PURE__*/React.createElement("small", {
          className: "form-text text-muted"
        }, "Private discussions require explicit invitations to join")), !this.state.values.isPrivate && /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "joinPolicy"
        }, "Join Policy"), /*#__PURE__*/React.createElement("select", {
          id: "joinPolicy",
          value: this.state.values.joinPolicy ? this.state.values.joinPolicy.name : '',
          onChange: this.handleJoinPolicyChange
        }, /*#__PURE__*/React.createElement("option", null), this.state.securityPolicyDefinitions.map(function (definition) {
          return /*#__PURE__*/React.createElement("option", {
            value: definition.name,
            key: definition.name
          }, definition.name);
        }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "owningUsers"
        }, "Owning Users"), /*#__PURE__*/React.createElement(OwningUsersInput, {
          id: "owningUsers",
          value: this.state.values.owningUsers,
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "owningTeams"
        }, "Owning Teams"), /*#__PURE__*/React.createElement(OwningTeamsInput, {
          id: "owningTeams",
          value: this.state.values.owningTeams,
          onChange: this.handleChange
        }), /*#__PURE__*/React.createElement("small", {
          className: "form-text text-muted"
        }, "Owning users and teams are able to make changes to the discussion")), /*#__PURE__*/React.createElement("hr", null), this.state.editing && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-check-inline"
        }, /*#__PURE__*/React.createElement("input", {
          className: "form-check-input",
          id: "isArchived",
          type: "checkbox",
          checked: this.state.values.isArchived,
          onChange: this.handleChange
        }), /*#__PURE__*/React.createElement("label", {
          className: "form-check-label",
          htmlFor: "isArchived"
        }, "Archived?")), /*#__PURE__*/React.createElement("small", {
          className: "form-text text-danger"
        }, "While archived, users are not able to send any messages")))),
        submit: this.submit,
        dirty: this.state.dirty,
        invalid: Object.keys(validations).length > 0,
        buttonProps: {
          onClick: this.submit,
          disabled: !this.state.dirty || this.state.saving || Object.keys(validations).length > 0
        }
      });
    }
  }]);

  return DiscussionForm;
}(React.Component);